import Vue from 'vue';

/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

import swal from 'sweetalert';
import Inputmask from "inputmask";
import VueInstantSearch from 'vue-instantsearch';
import Toasted from 'vue-toasted';
import VueRouter from 'vue-router';
Vue.use(VueRouter);



var VueCookie = require('vue-cookie');


Vue.use(VueCookie);
Vue.use(VueInstantSearch);
Vue.use(Toasted);


import VueInputmask from 'vue-inputmask';
Vue.use(VueInputmask);
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

Vue.component(
    'reviews', 
    () => import(
        /* webpackChunkName: "reviews" */
        './components/Reviews.vue'
    )
);

Vue.component(
    'test-search', 
    () => import(
        /* webpackChunkName: "reviews" */
        './components/TestSearch.vue'
    )
);

Vue.component(
    'crystal-identification', 
    () => import(
        /* webpackChunkName: "crystal-identification" */
        './components/identification/CrystalIdentification.vue'
    )
);

Vue.component(
    'related-products', 
    () => import(
        /* webpackChunkName: "related-products" */
        './components/crystals/RelatedProducts.vue'
    )
);

Vue.component(
    'subscribe-form-5', 
    () => import(
        /* webpackChunkName: "subscribe-form-5" */
        './components/subscription/SubscribeForm.vue'
    )
);

Vue.component(
    'subscribe-form-new', 
    () => import(
        /* webpackChunkName: "subscribe-form-new" */
        './components/subscription/SubscribeForm2.vue'
    )
);

Vue.component(
    'redemption-form-2', 
    () => import(
        /* webpackChunkName: "redemption-form-2" */
        './components/subscription/RedemptionForm.vue'
    )
);

Vue.component(
    'box-explore-more', 
    () => import(
        /* webpackChunkName: "box-explore-more" */
        './components/subscription/BoxExploreMore.vue'
    )
);


Vue.component(
    'gift-box-checkout-5', 
    () => import(
        /* webpackChunkName: "gift-box-checkout-5" */
        './components/subscription/GiftBoxCheckout.vue'
    )
);

Vue.component(
    'raffle-checkout', 
    () => import(
        /* webpackChunkName: "raffle-checkout" */
        './components/shop/RaffleTicket.vue'
    )
);

Vue.component(
    'gift-card-checkout', 
    () => import(
        /* webpackChunkName: "gift-card-checkout" */
        './components/shop/GiftCardCheckout.vue'
    )
);

Vue.component(
    'checkout-form-5', 
    () => import(
        /* webpackChunkName: "checkout-form-5" */
        './components/shop/CheckoutForm.vue'
    )
);

Vue.component(
    'checkout-form-square', 
    () => import(
        /* webpackChunkName: "checkout-form-square" */
        './components/shop/CheckoutFormSquare.vue'
    )
);

Vue.component(
    'shop-all', 
    () => import(
        /* webpackChunkName: "shop-all" */
        './components/shop/ShopAll.vue'
    )
);

Vue.component(
    'nft-discount', 
    () => import(
        /* webpackChunkName: "nft-discount" */
        './components/shop/NftDiscount.vue'
    )
);

Vue.component(
    'sync-product-to-wishlist-2', 
    () => import(
        /* webpackChunkName: "sync-product-to-wishlist-2" */
        './components/shop/SyncProductToWishlist.vue'
    )
);

Vue.component(
    'checkout-login-2', 
    () => import(
        /* webpackChunkName: "checkout-login-2" */
        './components/shop/CheckoutLogin.vue'
    )
);

Vue.component(
    'product', 
    () => import(
        /* webpackChunkName: "product" */
        './components/shop/Product.vue'
    )
);

Vue.component(
    'product-list-2', 
    () => import(
        /* webpackChunkName: "product-list-2" */
        './components/shop/ProductList.vue'
    )
);

Vue.component(
    'cart-2', 
    () => import(
        /* webpackChunkName: "cart-2" */
        './components/shop/Cart.vue'
    )
);

Vue.component(
    'add-to-cart-2', 
    () => import(
        /* webpackChunkName: "add-to-cart-test" */
        './components/shop/AddToCart.vue'
    )
);

Vue.component(
    'cart-mini-2', 
    () => import(
        /* webpackChunkName: "cart-mini-2" */
        './components/shop/CartMini.vue'
    )
);

Vue.component(
    'square-checkout-2', 
    () => import(
        /* webpackChunkName: "square-checkout" */
        './components/shop/SquareCheckout.vue'
    )
);

Vue.component(
    'payment-sources-3', 
    () => import(
        /* webpackChunkName: "payment-sources-3" */
        './components/shop/PaymentSources.vue'
    )
);


Vue.component(
    'crystal-actions-2', 
    () => import(
        /* webpackChunkName: "crystal-actions-2" */
        './components/CrystalActions.vue'
    )
);

Vue.component(
    'username-1', 
    () => import(
        /* webpackChunkName: "username-1" */
        './components/Username.vue'
    )
);


/**
 * ADMIN SEARCH
 */

Vue.component(
    'admin-chat', 
    () => import(
        /* webpackChunkName: "admin-chat" */
        './components/AdminChat.vue'
    )
);

Vue.component(
    'admin-search-bar', 
    () => import(
        /* webpackChunkName: "admin-search" */
        './components/admin_search/AdminSearchBar.vue'
    )
);

Vue.component(
    'dashboard', 
    () => import(
        /* webpackChunkName: "dashboard" */
        './components/Dashboard.vue'
    )
);

/**
 * LIVE SALE
 */

Vue.component(
    'live-sale-realtime', 
    () => import(
        /* webpackChunkName: "live-sale-realtime" */
        './components/live_sale/LiveSaleRealtime.vue'
    )
);

Vue.component(
    'live-sale-edit', 
    () => import(
        /* webpackChunkName: "live-sale-edit" */
        './components/live_sale/LiveSaleEdit.vue'
    )
);

Vue.component(
    'live-sale-selection', 
    () => import(
        /* webpackChunkName: "live-sale-selection" */
        './components/live_sale/LiveSaleSelection.vue'
    )
);


Vue.component(
    'live-sale-edit-product', 
    () => import(
        /* webpackChunkName: "live-sale-edit-product" */
        './components/live_sale/LiveSaleEditProduct.vue'
    )
);

Vue.component(
    'live-sale-invoices', 
    () => import(
        /* webpackChunkName: "live-sale-invoices" */
        './components/live_sale/LiveSaleInvoices.vue'
    )
);

Vue.component(
    'live-sale-2', 
    () => import(
        /* webpackChunkName: "live-sale-2" */
        './components/live_sale/LiveSale.vue'
    )
);

Vue.component(
    'live-sale-users', 
    () => import(
        /* webpackChunkName: "live-sale-users" */
        './components/live_sale/LiveSaleUsers.vue'
    )
);

Vue.component(
    'batch-list-portal', 
    () => import(
        /* webpackChunkName: "batch-list-portal" */
        './components/bulk_scroll/BatchListPortal.vue'
    )
);

Vue.component(
    'batch-list', 
    () => import(
        /* webpackChunkName: "batch-list" */
        './components/bulk_scroll/BatchList.vue'
    )
);

Vue.component(
    'future-crystals-portal', 
    () => import(
        /* webpackChunkName: "batch-list" */
        './components/scroll/FutureCrystalsPortal.vue'
    )
);

Vue.component(
    'ai-suggestion-box', 
    require('./components/bulk_scroll/AISuggestionBox.vue').default
);

Vue.component('google-address-autocomplete', require('./components/shop/GoogleAddressAutocomplete.vue').default);

Vue.component('GiftForm', require('./components/subscription/GiftForm.vue').default);
Vue.component('CommentForm', require('./components/CommentForm.vue').default);
Vue.component('autocomplete',require('./components/Autocomplete.vue').default);
Vue.component('newslettersubscribe',require('./components/NewsletterSubscribe.vue').default);
Vue.component('newslettersubscribe-popup',require('./components/NewsletterSubscribePopup.vue').default);
Vue.component('search', require('./components/MySearch.vue').default);
Vue.component('public-search', require('./components/PublicSearch.vue').default);
Vue.component('Phone', require('./components/Phone.vue').default);

Vue.component('OutOfStockButton', require('./components/shop/OutOfStockButton.vue').default);
Vue.component('MobileMainMenu', require('./components/menus/MobileMainMenu.vue').default);
Vue.component('MobileUserMenu', require('./components/menus/MobileUserMenu.vue').default);

Vue.component(
    'shop-search', 
    () => import(
        /* webpackChunkName: "shop-search" */
        './components/ShopSearch.vue'
    )
);

Vue.component(
    'crystal-list', 
    () => import(
        /* webpackChunkName: "crystal-list" */
        './components/CrystalList.vue'
    )
);

Vue.component(
    'quiz', 
    () => import(
        /* webpackChunkName: "quiz" */
        './components/Crystals/Quiz.vue'
    )
);
Vue.component(
    'desktop-user-menu', 
    () => import(
        /* webpackChunkName: "desktop-user-menu" */
        './components/menus/DesktopUserMenu.vue'
    )
);
Vue.component(
    'admin-product-edit', 
    () => import(
        /* webpackChunkName: "admin-product-edit" */
        './components/shop/AdminProductEdit.vue'
    )
);

Vue.component(
    'invoice-payment-5', 
    () => import(
        /* webpackChunkName: "invoice-payment-5" */
        './components/shop/InvoicePayment.vue'
    )
);

Vue.component(
    'invoice-payment-square', 
    () => import(
        /* webpackChunkName: "invoice-payment-square" */
        './components/shop/InvoicePaymentSquare.vue'
    )
);

Vue.component(
    'custom-scroll-response-portal', 
    () => import(
        /* webpackChunkName: "custom-scroll-response-portal" */
        './components/scroll_response_manager/CustomScrollResponsePortal.vue'
    )
);

Vue.component(
    'bulk-scroll-portal', 
    () => import(
        /* webpackChunkName: "bulk-scroll-portal" */
        './components/bulk_scroll/BulkScrollPortal.vue'
    )
);

Vue.component(
    'subscription-batch-portal', 
    () => import(
        /* webpackChunkName: "subscription-batch-portal" */
        './components/bulk_scroll/SubscriptionBatchPortal.vue'
    )
);

Vue.component(
    'scroll-portal', 
    () => import(
        /* webpackChunkName: "scroll-portal" */
        './components/scroll/ScrollPortal.vue'
    )
);

Vue.component(
    'list', 
    () => import(
        /* webpackChunkName: "list" */
        './components/scroll/List.vue'
    )
);

Vue.component(
    'scroll-settings', 
    () => import(
        /* webpackChunkName: "scroll-settings" */
        './components/scroll/ScrollSettings.vue'
    )
);

Vue.component(
    'scroll-locked', 
    () => import(
        /* webpackChunkName: "scroll-locked" */
        './components/scroll/ScrollLocked.vue'
    )
);

Vue.component(
    'scroll-search', 
    () => import(
        /* webpackChunkName: "scroll-search" */
        './components/scroll/ScrollSearch.vue'
    )
);

Vue.component(
    'single-item', 
    () => import(
        /* webpackChunkName: "single-item" */
        './components/scroll/SingleItem.vue'
    )
);

Vue.component(
    'subscription-history', 
    () => import(
        /* webpackChunkName: "subscription-history" */
        './components/scroll/SubscriptionHistory.vue'
    )
);

Vue.component(
    'copy-to-clipboard', 
    () => import(
        /* webpackChunkName: "copy-to-clipboard" */
        './components/CopyToClipboard.vue'
    )
);

Vue.component(
    'currency-settings', 
    () => import(
        /* webpackChunkName: "currency-settings" */
        './components/CurrencySettings.vue'
    )
);

Vue.component(
    'printer-portal', 
    () => import(
        /* webpackChunkName: "printer-portal" */
        './components/PrinterPortal.vue'
    )
);

Vue.component(
    'nft-checkout', 
    () => import(
        /* webpackChunkName: "nft-checkout" */
        './components/nft/NftCheckout.vue'
    )
);

Vue.component(
    'nft-viewer', 
    () => import(
        /* webpackChunkName: "nft-viewer" */
        './components/nft/NftViewer.vue'
    )
);

Vue.component(
    'nft-wallet', 
    () => import(
        /* webpackChunkName: "nft-wallet" */
        './components/nft/NftWallet.vue'
    )
);

const routes = [
]
var router = new VueRouter({
  routes: routes,
  mode: 'history'
})

new Vue({
  el: '#app',
  router: router
})


